import { useMutation, useQuery } from '@apollo/client'
import { HamburgerIcon, LockIcon, QuestionIcon, StarIcon } from '@chakra-ui/icons'
import {
  Box,
  Grid, GridItem,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useToast
} from '@chakra-ui/react'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { FaUserAlt } from "react-icons/fa"
import { MdRealEstateAgent } from "react-icons/md"
import { TbLogout } from "react-icons/tb"
import { Route, Routes, useNavigate } from 'react-router-dom'
import ProfileFooter from '../../Components/Footer/ProfileFooter'
import { UPDATE_PROFILE_DATA_MUTATION } from '../../Components/Graphql/Mutations'
import { GET_USER_DATA } from '../../Components/Graphql/Queries'
import ProfileSidebar from '../../Components/Sidebar/ProfileSidebar'
import ChangePassword from './ChangePassword'
import Favourites from './Favourites'
import InterestedProperties from './InterestedProperties'
import UserProfile from './UserProfile'

const Profile = () => {
  const navigate = useNavigate();
  const handleLogoutClick = () => {
    sessionStorage.removeItem('token');
    window.location.reload();
  }
  const toast = useToast();
  const [updateProfileDataMutation, updateProfileData] = useMutation(UPDATE_PROFILE_DATA_MUTATION);
  const { loading, error, data, refetch } = useQuery(GET_USER_DATA);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(false);



  const token = sessionStorage.getItem('token');


  useEffect(() => {

    console.log("error in update profile mutation:", updateProfileData.error)
    console.log("loading update profile mutation:", updateProfileData.loading)
    console.log("data update profile mutation:", updateProfileData.data)

    if (updateProfileData.data != undefined) {
      if (updateProfileData?.data?.updateProfileData?.success) {
        toast({
          title: 'Succeed',
          description: 'Profile Updated Successfully',
          status: 'success',
          duration: 4000,
          isClosable: true,
          position: "bottom-left"
        });
      }
      else {
        toast({
          title: 'error',
          description: updateProfileData?.data?.updateProfileData?.message,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: "bottom-left"
        });
      }

    }
    if (updateProfileData.error != undefined) {
      toast({
        title: 'error',
        description: updateProfileData.error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    }
  }, [updateProfileData.data, updateProfileData.loading, updateProfileData.error])

  
  useEffect(() => {

    console.log("error:", error)
    console.log("loading:", loading)
    console.log("data:", data)

    if (data != undefined) {
      console.log("data of user: ", data);
      setFirstName(data.getUserData.firstName);
      setLastName(data.getUserData.lastName);
      setEmail(data.getUserData.email)
      setPhoneNo(data.getUserData.phoneNumber)
      setProfileUrl(data.getUserData.profileImage)

      console.log("firstName", firstName);
    }
    if (error != undefined) {
      toast({
        title: 'error',
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    }
  }, [data, loading, error])

 

  return (
    <Box>
      <Box display='flex' alignItems='center' justifyContent='center' background='#FAFAFA' padding={{ base: '0 12px 35px', xl: '60px 12px 35px' }}>
        <Box maxWidth='1300px' minH="55vh" w={{ base: '100%', sm: '83%' }} marginTop='35px' paddingX='10px'>
          <Grid templateColumns='repeat(12, 1fr)' gap={{ base: 2, xl: 10 }} w='100%'>
            <GridItem colSpan={{ base: 0, xl: 3 }} display={{ base: 'none', xl: 'block' }}>
              <ProfileSidebar />
            </GridItem>
            <GridItem colSpan={{ base: 12, xl: 9 }} w='100%'>
              <Box mb="30px" display={{ base: 'block', xl: 'none' }}>
                <Menu>
                  <MenuButton as={IconButton} icon={<HamburgerIcon />} />
                  <MenuList>
                    <MenuItem onClick={() => navigate('/profile')} icon={<FaUserAlt />}>
                      Profile
                    </MenuItem>
                    <MenuItem onClick={() => navigate('/profile/favourites')} icon={<StarIcon />}>
                      Favourite Properties
                    </MenuItem>
                    <MenuItem onClick={() => navigate('/profile/interested-properties')} icon={<MdRealEstateAgent />}>
                      Interested Properties
                    </MenuItem>
                    <MenuItem onClick={() => navigate('/questionnaire')} icon={<QuestionIcon />}>
                      Questionnaire
                    </MenuItem>
                    <MenuItem onClick={() => navigate('/profile/change-password')} icon={<LockIcon />}>
                      Change Password
                    </MenuItem>
                    <MenuItem onClick={handleLogoutClick} icon={<TbLogout />}>
                      Logout
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Box>
              <Box w='100%'>
                <Routes>
                  <Route path={'/'} element={<UserProfile />} />
                  <Route path={'/favourites'} element={<Favourites />} />
                  <Route path={'/interested-properties'} element={<InterestedProperties />} />
                  <Route path={'/change-password'} element={<ChangePassword />} />
                </Routes>

              </Box>
            </GridItem>
          </Grid>
        </Box>
      </Box>
      <ProfileFooter />
    </Box>
  )
}

export default Profile